<template>
  <div id="about-page">
    <div id="fullpage" >
      <div class="section section1">
        <div class="container">
          <h3>
            What Makes Us Special?
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
          </h3>

          <div class="row">
            <div class="col-md-4">
              <img src="../assets/about-poly1.png" alt="">
              <p class="text-left">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident.</p>
            </div>
            <div class="col-md-4">
              <img src="../assets/about-poly2.png" alt="">
              <p class="text-left">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident.</p>
            </div>
            <div class="col-md-4">
              <img src="../assets/about-poly3.png" alt="">
              <p class="text-left">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="section section2">
        <div class="container">
          <h3>Fueling Creativity</h3>
          <!-- <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p> -->
          <img src="../assets/brainstorm.png" alt="">
            <p class="text-left">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
            <p class="text-left">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
        </div>
      </div>
      <div class="section team">
        <div class="container">
          <h3>Team of Experts</h3>
          <div class="row">
            <div class="col-md-3 col-sm-6">
              <img class="img-circle" src="../assets/face1.png" alt="">
            </div>
            <div class="col-md-3 col-sm-6">
              <img class="img-circle" src="../assets/face2.png" alt="">
            </div>
            <div class="col-md-3 col-sm-6">
              <img class="img-circle" src="../assets/face3.png" alt="">
            </div>
            <div class="col-md-3 col-sm-6">
              <img class="img-circle" src="../assets/face4.png" alt="">
            </div>
          </div>
          <div class="block">
            <p class="text-left">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
            <p class="text-left">Lorem ipsum olor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
          </div>
        </div>
      </div>
      <div class="section section3">
        <div class="container">
          <h3>Our Corporate Family</h3>
          <div class="row">
            <div class="col-md-3 col-sm-6">
              <img src="../assets/logo_barouti.png" alt="">
            </div>
            <div class="col-md-3 col-sm-6">
              <img src="../assets/logo_martindale.png" alt="">
            </div>
            <div class="col-md-3 col-sm-6">
              <img src="../assets/logo_deilami.png" alt="">
            </div>
            <div class="col-md-3 col-sm-6">
              <img src="../assets/logo_jeffreys.png" alt="">
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 col-sm-6">
              <img src="../assets/logo_fixit.png" alt="">
            </div>
            <div class="col-md-3 col-sm-6">
              <img src="../assets/logo_elpollo.png" alt="">
            </div>
            <div class="col-md-3 col-sm-6">
              <img src="../assets/logo_telaviv.png" alt="">
            </div>
            <div class="col-md-3 col-sm-6">
              <img src="../assets/logo_appanapp.png" alt="">
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 col-sm-6">
              <img src="../assets/logo_crs.png" alt="">
            </div>
            <div class="col-md-3 col-sm-6">
              <img src="../assets/logo_crs.png" alt="">
            </div>
            <div class="col-md-3 col-sm-6">
              <img src="../assets/logo_crs.png" alt="">
            </div>
            <div class="col-md-3 col-sm-6">
              <img src="../assets/logo_crs.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="section section4">
        <h3>Did We Get Your Attention?</h3>
        <section-button :btnText="btnText"/>
        <div class="row">
          <div class="col-md-4 hidden-sm hidden-xs">
            <img class="img-responsive" src="../assets/about-map.png" alt="">
          </div>
          <div class="col-md-4 hidden-sm hidden-xs">
            <!-- <img class="img-responsive" src="../assets/about-map.jpg" alt=""> -->
          </div>
          <div class="col-md-4">
            <img class="img-responsive" src="../assets/about-app.jpg" alt="">
          </div>
        </div>
      </div>
      <div id="footer" class="section fp-auto-height">
        <app-footer />
      </div>
    </div>
  </div>
</template>

<script>
  import AppFooter from '@/components/AppFooter'
  import SectionButton from '@/components/SectionButton'

  export default {
    name: 'about-page',
    components: {
      AppFooter,
      SectionButton
    },
    data () {
      return {
        footerBg: '#333',
        btnText: 'Get Started Now'
      }
    },
    methods: {
      navigate(index) {
        $.fn.fullpage.moveTo(index);
      }
    },
    mounted() {
      let vm = this;

      if($('html').hasClass('fp-enabled')){
          $.fn.fullpage.destroy('all');
      }
      $('#fullpage').fullpage({
        paddingTop: '50px',
        scrollOverflow: true,
        afterLoad: function(anchorLink, index) {
          // vm.nav['section' + index] = true;
          // (index == 6) ? $('#sidebar-nav').fadeOut() : $('#sidebar-nav').fadeIn()
      	},
        onLeave: function(index, nextIndex, direction){
          // vm.nav['section' + index] = false;
          // vm.sections[index - 2].enter = false;
      	},
      });
    }
  }
</script>

<style scoped lang="sass">
#about-page
  // padding-top: 50px
  .section
    background-size: cover !important
    background-color: #222
    color: white
    text-align: center
    // padding-bottom: 80px
    // padding: 80px 0 80px 0
    &.team
      background: url('../assets/team-bg.jpg') no-repeat center center
      .block
        background: rgba(0,0,0,.5)
        border-radius: 5px
        padding: 20px
    .container
      margin-bottom: 50px
      h3
        text-align: center
        font-size: 3em
        text-transform: uppercase
        font-weight: 600
        margin-bottom: 50px
        @media screen and (max-width: 767px)
          font-size: 1.2em
          margin-bottom: 10px
        p
          font-size: 16px
          line-height: 20px
          font-weight: 400
          text-transform: initial
          margin-top: 10px
          @media screen and (max-width: 767px)
            font-size: 12px
      p
        @media screen and (max-width: 767px)
          font-size: 12px
      img
        max-width: 100%
        margin: 20px auto

  .section1
    background: #000000
    background: -moz-linear-gradient(top,  #000000 0%, #373737 100%)
    background: -webkit-linear-gradient(top,  #000000 0%,#373737 100%)
    background: linear-gradient(to bottom,  #000000 0%,#373737 100%)
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#000000', endColorstr='#373737',GradientType=0)
  .section2
    background: #373737
    background: -moz-linear-gradient(top,  #373737 0%, #000000 100%)
    background: -webkit-linear-gradient(top,  #373737 0%,#000000 100%)
    background: linear-gradient(to bottom,  #373737 0%,#000000 100%)
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#373737', endColorstr='#000000',GradientType=0 )
  .section3
    // background: #000000
    // background: -moz-linear-gradient(top,  #000000 0%, #ffffff 100%)
    // background: -webkit-linear-gradient(top,  #000000 0%,#ffffff 100%)
    // background: linear-gradient(to bottom,  #000000 0%,#ffffff 100%)
    // filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#000000', endColorstr='#ffffff',GradientType=0 )
    background: #000000
    background: -moz-linear-gradient(top,  #000000 0%, #fbfbfb 100%)
    background: -webkit-linear-gradient(top,  #000000 0%,#fbfbfb 100%)
    background: linear-gradient(to bottom,  #000000 0%,#fbfbfb 100%)
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#000000', endColorstr='#fbfbfb',GradientType=0)
  .section4
    background: #fbfbfb
    // background: -moz-linear-gradient(top,  #373737 0%, #000000 100%)
    // background: -webkit-linear-gradient(top,  #373737 0%,#000000 100%)
    // background: linear-gradient(to bottom,  #373737 0%,#000000 100%)
    // filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#373737', endColorstr='#000000',GradientType=0 )
    h3
      color: black
      text-transform: uppercase
      font-size: 3.5em
      font-weight: 700
      @media screen and (max-width: 767px)
        font-size: 1.2em
        margin-bottom: 10px
    button
      background: purple !important
</style>



// WEBPACK FOOTER //
// AboutPage.vue?8e703662